import { render } from "./QuestsMain.vue?vue&type=template&id=303b4450&scoped=true"
import script from "./QuestsMain.vue?vue&type=script&lang=js"
export * from "./QuestsMain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303b4450"]])

export default __exports__